import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { FormTemplate } from 'api/form/types';
import { Form } from 'components/atoms/form';
import { Input, TextArea } from 'components/atoms/input';
import { useTranslation } from 'hooks/use-translation';
import { useFormTemplateUpdateMutation } from 'queries/form-template';
import { isFormValid } from '../utils';

const StyledForm = styled(Form)`
  height: 100%;
  overflow: scroll;
  padding: var(--layout-02) var(--layout-01);
`;

export const FormHeaderConfiguration: FC<{ formTemplate: FormTemplate }> = ({
  formTemplate,
}) => {
  const [form] = Form.useForm();
  const requiredMessage = useTranslation('input.required');
  const { mutate } = useFormTemplateUpdateMutation(formTemplate.templateId);

  const triggerOnChange = () => {
    if (isFormValid(form)) {
      mutate(form.getFieldsValue(['name', 'description']));
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      name: formTemplate.name,
    });
  }, [form, formTemplate.name]);

  return (
    <StyledForm
      form={form}
      name="form_header_configuration"
      autoComplete="off"
      initialValues={{
        name: formTemplate.name,
        description: formTemplate.description,
      }}
      preserve={false}
      layout="vertical"
    >
      <Form.Item
        name="name"
        label={<FormattedMessage id="form_templates.title" />}
        rules={[{ required: true, message: requiredMessage }]}
      >
        <Input autoFocus onBlur={() => triggerOnChange()} />
      </Form.Item>
      <Form.Item
        name="description"
        label={<FormattedMessage id="form_templates.description" />}
      >
        <TextArea
          autoSize={{ minRows: 3, maxRows: 3 }}
          onBlur={() => triggerOnChange()}
        />
      </Form.Item>
    </StyledForm>
  );
};
